export const CONST = {
  INTERPRETATION_FILTER_KEY: "INTERPRETATION_FILTER_KEY",
  TRANSLATION_FILTER_KEY: "TRANSLATION_FILTER_KEY",
  OTHER_FILTER_KEY: "OTHER_FILTER_KEY",
  INVOICES_FILTER_KEY: "INVOICES_FILTER_KEY",
  SERVICE_FILTER_KEY: "SERVICE_FILTER_KEY",

  INTERPRETATION_SORT_KEY: "INTERPRETATION_SORT_KEY",
  TRANSLATION_SORT_KEY: "TRANSLATION_SORT_KEY",
  OTHER_SORT_KEY: "OTHER_SORT_KEY",
  INVOICES_SORT_KEY: "INVOICES_SORT_KEY",
  SERVICE_SORT_KEY: "SERVICE_SORT_KEY",

  INTERPRETATION_MONTHS_KEY: "INTERPRETATION_MONTHS_KEY",
  INTERPRETATION_YEAR_KEY: "INTERPRETATION_YEAR_KEY",
  INTERPRETATIONS_SHOW_TOTALS_KEY: "SERVICE_SHOW_TOTALS_KEY",
  CLIENT_PROFILE_SHOW_TOTALS_KEY: "SERVICE_SHOW_TOTALS_KEY",
  LINGUIST_PROFILE_SHOW_TOTALS_KEY: "SERVICE_SHOW_TOTALS_KEY",

  TRANSLATION_MONTHS_KEY: "TRANSLATION_MONTHS_KEY",
  TRANSLATION_YEAR_KEY: "TRANSLATION_YEAR_KEY",
  TRANSLATIONS_SHOW_TOTALS_KEY: "SERVICE_SHOW_TOTALS_KEY",

  SERVICE_MONTHS_KEY: "SERVICE_MONTHS_KEY",
  SERVICE_YEAR_KEY: "SERVICE_YEAR_KEY",
  SERVICES_FOOTER_VIEW_KEY: "SERVICES_FOOTER_VIEW_KEY",

  OTHER_SERVICE_MONTHS_KEY: "OTHER_SERVICE_MONTHS_KEY",
  OTHER_SERVICE_YEAR_KEY: "OTHER_SERVICE_YEAR_KEY",
  OTHER_SERVICES_SHOW_TOTALS_KEY: "SERVICE_SHOW_TOTALS_KEY",

  INVOICES_MONTHS_KEY: "INVOICES_MONTHS_KEY",
  INVOICES_YEAR_KEY: "INVOICES_YEAR_KEY",

  INTERPRETATION_LINGUIST_FILTER_KEY: "INTERPRETATION_LINGUIST_FILTER_KEY",
  INTERPRETATION_LINGUIST_SORT_KEY: "INTERPRETATION_LINGUIST_SORT_KEY",
  INTERPRETATIONS_LINGUIST_COLUMNS_VISIBLE: "INTERPRETATIONS_LINGUIST_COLUMNS_VISIBLE",
  INTERPRETATIONS_LINGUIST_GRID_DENSITY: "INTERPRETATIONS_LINGUIST_GRID_DENSITY",
};
